export default "__VITE_ASSET__dba3e306__"